import { MapPin } from "lucide-react";
import { NAV_LINKS, BUSINESS_LOCATION } from "../config";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-navy-950">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div>
            <img
              src="/logo-full.webp"
              alt="EXIMNEX Technologies logo"
              width="900"
              height="731"
              loading="lazy"
              className="h-20 w-auto"
            />
            <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.24em] text-white/40">
              Global Trade Intelligence
            </p>
          </div>

          <nav className="flex flex-col gap-3 md:items-end" aria-label="Footer">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`footer-nav-${l.id}`}
                className="text-[12px] font-semibold uppercase tracking-[0.16em] text-white/50 transition-colors hover:text-white"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-white/10 pt-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-white/40" data-testid="footer-copyright">
            © 2026 EXIMNEX Technologies. All Rights Reserved.
          </p>
          <p
            className="flex items-center gap-1.5 text-xs text-white/35"
            data-testid="footer-location"
          >
            <MapPin className="h-3.5 w-3.5" />
            {BUSINESS_LOCATION}
          </p>
        </div>
      </div>
    </footer>
  );
}
